<template>
  <div class="alert alert-danger" role="alert">
    This account already has a paid subscription. Please visit <a :href="subsMgmtV2Url + '/account'" class="alert-link text-primary">your account dashboard</a> to manage your subscription or upgrade.
  </div>
</template>
<script setup>
const subsMgmtV2Url = import.meta.env.VITE_SUBS_MGMT_V2_URL;
</script>
